module.exports = TheliaBlocks;